import brands from './partners.json';

// Entries without an image stay in the list for later, but do not create blank slots.
export const partnerBrands = brands
  .filter(({ name, file }) => name && file)
  .map(({ name, file }) => {
    const base = file.replace(/\.png$/i, '');
    return {
      name,
      lightLogo: `/brands/${base}-light.png`,
      darkLogo: `/brands/${base}-dark.png`,
    };
  });
